import { toast } from "react-toastify";
import { GetAllContractorsApi } from "../../../Api/Operations/Contractors";

/**
 * Contractors Redux Actions
 * Pattern: Action creator + Async thunk with error handling
 */

// Synchronous Action Creator
export const GetAllContractors = (data) => {
  return {
    type: "get_all_contractors",
    payload: data,
    loader: false,
  };
};

// Async Thunk - Fetch all contractors
export function getallContractors(projectId) {
  return async (dispatch) => {
    try {
      const result = await GetAllContractorsApi(projectId);

      if (result.data?.IsSuccess === true) {
        dispatch(GetAllContractors(result.data.Data));
      } else {
        toast.error(result.data?.Message || "Failed to fetch contractors");
      }
    } catch (error) {
      toast.error("Something went wrong while fetching contractors!");
    }
  };
}
